import environment from '#/environment/environment';
import {localhost, mainnet, polygonAmoy} from 'wagmi/chains';

const chainsWithKeys = {
  localhost,
  polygonAmoy,
};

export const getChains = () => {
  if (!Object.keys(chainsWithKeys).includes(environment.chainKey)) {
    throw new Error(`Chain with key ${environment.chainKey} not found`);
  }

  const chainFromEnv = chainsWithKeys[environment.chainKey as keyof typeof chainsWithKeys];
  return [chainFromEnv, mainnet] as const;
};
